import React, { useState } from 'react';
import Styles from './BensServicosPJConfiraPassoAPasso.css';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function BensServicosPJConfiraPassoAPasso() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="bens-servicos-pf-confira-passo-a-passo">
        <ContainerHome24>
          <div id="bens-servicos-pf-confira">
            <h2 className="confira-title">Confira todas as facilidades que você tem com a gente</h2>
            <div className="confira-carrossel">
              <CustomEmblaCarouselHome24
                enableBullets
                detectBulletCount
                enableMobileArrows
                enablePrevArrow
              >
                {({ className }) => (
                  <>
                    <div className={`confira-carrossel-slide ${className}`}>
                      <img
                        src="assets/bens-e-servicos/confira-carrossel/ic_schedule_spending.svg"
                        alt=""
                      />
                      <p className="slide-texto">
                        Parcelas
                        <br />
                        estendidas
                      </p>
                    </div>
                    <div className={`confira-carrossel-slide ${className}`}>
                      <img src="assets/bens-e-servicos/confira-carrossel/ic_card.svg" alt="" />
                      <p className="slide-texto">
                        Impulsione seu
                        <br />
                        negócio
                      </p>
                    </div>
                    <div className={`confira-carrossel-slide ${className}`}>
                      <img
                        src="assets/bens-e-servicos/confira-carrossel/ic_business_store.svg"
                        alt=""
                      />
                      <p className="slide-texto">
                        Mais de 20 mil
                        <br />
                        lojas parceiras
                      </p>
                    </div>
                    <div className={`confira-carrossel-slide ${className}`}>
                      <img src="assets/bens-e-servicos/confira-carrossel/ic_security.svg" alt="" />
                      <p className="slide-texto">Segurança</p>
                    </div>
                    <div className={`confira-carrossel-slide ${className}`}>
                      <img
                        src="assets/bens-e-servicos/confira-carrossel/ic_clock_urgent.svg"
                        alt=""
                      />
                      <p className="slide-texto">Rapidez</p>
                    </div>
                  </>
                )}
              </CustomEmblaCarouselHome24>
            </div>
          </div>
          <div id="bens-servicos-pf-passo-a-passo">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <img
                    src="assets/bens-e-servicos/img-passo-a-passo.svg"
                    alt=""
                    className="img-passo-a-passo"
                  />
                )}
                {width > 992 && (
                  <img
                    src="assets/bens-e-servicos/img-passo-a-passo-desk.svg"
                    alt=""
                    className="img-passo-a-passo"
                  />
                )}{' '}
              </>
            )}

            <div className="passo-a-passo-titles">
              <h2 className="passo-a-passo-title">Passo a passo para parcelar sua compra</h2>
              <p className="passo-a-passo-subtitle">
                Confira o passo a passo abaixo e conte com todas as vantagens de contar com a gente:
              </p>
            </div>
            <div className="passo-a-passo-passos">
              <p className="passo-a-passo-passo">
                <b>1.</b> Consulte acima tudo que você pode parcelar com a gente;
              </p>
              <p className="passo-a-passo-passo">
                <b>2.</b> Escolha exatamente o que você deseja parcelar;
              </p>
              <p className="passo-a-passo-passo">
                <b>3.</b> <a href="#bens-servicos-busca-loja">Encontre a loja parceira</a> Santander
                mais perto de você;
              </p>
              <p className="passo-a-passo-passo">
                <b>4.</b> Pague suas parcelas de forma facilitada.
              </p>
            </div>
          </div>
        </ContainerHome24>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosPJConfiraPassoAPasso;
